module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro.899c8f7.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro.woff2
// module id = 55b4
// module chunks = 4